import { useEffect } from 'react';
import { MATCH_CODE_RE } from './shared/constants';
import { ConfirmHost } from './components/Confirm';
import { GuaaPopupHost } from './components/GuaaPopup';
import { Toasts } from './components/ui';
import { usePath } from './lib/router';
import { setToken } from './lib/store';
import { toast } from './lib/toast';
import { Dashboard } from './screens/Dashboard';
import { EndScreen } from './screens/EndScreen';
import { Home } from './screens/Home';
import { Setup } from './screens/Setup';
import { NotFound } from './screens/shared';
import { OnlineRoom } from './screens/online/OnlineRoom';
import { Teams } from './screens/Teams';
import { Welcome } from './screens/Welcome';
import { WheelScreen } from './screens/WheelScreen';

function route(path: string) {
  if (path === '/') return <Welcome />;
  if (path === '/home') return <Home />;
  if (path === '/new') return <Setup />;
  if (path === '/new/teams') return <Teams />;
  const r = path.match(/^\/r\/([^/]+)\/?$/);
  if (r) {
    const code = decodeURIComponent(r[1]!).toUpperCase();
    if (!MATCH_CODE_RE.test(code)) return <NotFound message="That doesn't look like a table code." />;
    return <OnlineRoom key={code} code={code} />;
  }
  const m = path.match(/^\/m\/([^/]+)(?:\/(wheel|end))?\/?$/);
  if (m) {
    const code = decodeURIComponent(m[1]!).toUpperCase();
    if (!MATCH_CODE_RE.test(code)) return <NotFound message="That doesn't look like a match code." />;
    if (m[2] === 'wheel') return <WheelScreen key={code} code={code} />;
    if (m[2] === 'end') return <EndScreen key={code} code={code} />;
    return <Dashboard key={code} code={code} />;
  }
  return <NotFound message="Page not found" />;
}

/** Editor links look like /m/RANG-7KQ2#edit=<token>; store the token and clean the URL. */
function useEditTokenFromHash(path: string) {
  useEffect(() => {
    const m = path.match(/^\/m\/([^/]+)/);
    const token = new URLSearchParams(location.hash.slice(1)).get('edit');
    if (!m || !token) return;
    setToken(decodeURIComponent(m[1]!).toUpperCase(), token);
    history.replaceState(null, '', location.pathname + location.search);
    toast('You can now record deals for this match.', 'success');
  }, [path]);
}

export function App() {
  const path = usePath();
  useEditTokenFromHash(path);
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded focus:bg-cream focus:px-3 focus:py-2 focus:text-ink">
        Skip to content
      </a>
      <div id="main">{route(path)}</div>
      <ConfirmHost />
      <GuaaPopupHost />
      <Toasts />
    </>
  );
}
